interface JwtPayload {
	data: Record<string, any>;
	exp: number;
	iat: number;
	iss: string;
	sub?: string;
}

export default function decodeJwt(token: string): JwtPayload {
	// Split the token into its three parts: header, payload, and signature
	const parts = token.split('.');

	// The payload is the second part (index 1)
	const payload = parts[1];

	// Decode the base64url-encoded payload
	const decodedPayload = atob(payload.replace(
		/-/g,
		'+',
	).replace(
		/_/g,
		'/',
	));

	// Parse the JSON string and cast to the JwtPayload interface
	return JSON.parse(decodedPayload) as JwtPayload;
}
